<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Nuevo Proveedor &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
      FormProveedor(:bancos="bancos" :municipios="municipios" :proveedor_edit="editProveedor" @saveForm="saveForm")
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import FormProveedor from '@/components/requisiciones_Componentes/FormProveedor.vue'

  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'

  export default {
    name: 'ProveedorPendienteEditar',
    components: { Loader, NavBarInventario, FormProveedor },
    data() {
      return {
        isLoading: false,
        bancos: [],
        //municipios: json.map(this.convertirDataMunicipios),
        municipios: [],
        editProveedor: {}
      }
    },
    methods: {
      iniciarComponente() {
        this.isLoading = true
        this.getBancos()
      },
      getBancos() {
        InventarioServices.getBancos()
          .then((data) => {
            this.bancos = data.map(this.convertirData)
            this.getMunicipios()
          })
          .catch((error) => {
            this.displayToast(error.message,'ban', 'Ok')
          })
      },
      getMunicipios() {
        InventarioServices.getMunicipios()
          .then((data) => {
            this.municipios = data
            this.tansformData()
            
            this.isLoading = false
          })
          .catch((error) => {
            this.displayToast(error.message,'ban', 'Ok')
            this.isLoading = false
          })
      },
      tansformData() {
        this.municipios = this.municipios.map(this.convertirDataMunicipios)
        if (Object.keys(this.proveedorEdit).length > 0) {
          this.editProveedor = this.proveedorEdit
        }
      },
      convertirData(bank) {
        return {
          ...bank,
          id: parseInt(bank.id)
        }
      },
      convertirDataMunicipios(city) {
        return {
          ...city,
          id: Number(city.id)
        }
      },
      backPage () {
        this.editProveedor = {}
        this.$store.commit('editarProveedor', {})
        this.$router.back()
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      saveForm(prov) {

        let nacional = 0
        if (prov.isNacional) {
          nacional = 1
        } else {
          nacional = 0
        }

        InventarioServices.editProveedor(this.proveedorEdit.id, prov.nombre, prov.rfc, prov.telefono1, prov.telefono2, prov.telefono3, prov.ext, prov.pais, prov.estadoSel, prov.ciudad, prov.colonia, prov.calle, prov.numExt, prov.numInt, prov.cp, prov.contacto, prov.email, prov.credito, prov.cuenta, prov.clabe, nacional, prov.idBanco, prov.efectivo)
          .then((data) => {
            if (data.success) {
              this.displayToast(data.respuesta, 'done', 'OK')
              this.backPage()
            } else {
              this.displayToast(data.respuesta, 'ban','OK')
            }
          }) 
          .catch( e => this.displayToast(e.message, 'ban', 'OK'))
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'proveedorEdit'])
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ProveedoresPendientesEditar.vue